import React from 'react';

export default function OlxLogo() {
  return (
    <svg
      width="150px" /* Adjusted width for a wordmark vs a square icon */
      height="48px"
      viewBox="0 0 300 80"
      xmlns="http://www.w3.org/2000/svg"
      style={{ display: 'inline-block', verticalAlign: 'middle' }}
    >
      <defs>
        <style>{`
          .text-main { font-family: Arial, sans-serif; font-weight: 900; font-size: 60px; letter-spacing: -2px; }
          .green-part { fill: #0F4424; }
          .gold-part { fill: #C9A84C; }
        `}</style>
      </defs>

      <text x="0" y="60" className="text-main">
        <tspan className="green-part">Club</tspan>
        <tspan className="gold-part">Loop</tspan>
      </text>
    </svg>
  );
}
